module.exports = __webpack_public_path__ + "img/logoumfd.c353508e.png";